export const lgSpace = "24px";
export const mdSpace = "18px";
export const smSpace = "12px";

export const primaryColor = "#ff6600";

export const colors = {
  error: "#ff7171",
  grey: "#d7d7d7",
  info: "#2b78e4",
  primary: primaryColor,
  success: "#14a38b",
  warning: "#f2ac57",
  greyLine: "#d3d3d3",
};

export const screenSize = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px",
};

export const fontSize = {
  main: "18px",
  secondary: "16px",
};
